import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs';
import { AppModeService } from 'src/app/services/app-mode.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
})
export class RegisterComponent implements OnInit {
  isMobileApp = false;
  nameValue = '';
  emailValue = '';
  mobileValue = '';
  passwordValue = '';
  showPassword = false;
  isLoading = false;
  nameError = '';
  emailError = '';
  mobileError = '';
  passwordError = '';
  registerError = '';

  constructor(
    private readonly appModeService: AppModeService,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.isMobileApp = this.appModeService.isApp();
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  clearField(field: 'name' | 'email' | 'mobile' | 'password'): void {
    if (field === 'name') {
      this.nameValue = '';
      this.nameError = '';
      return;
    }

    if (field === 'email') {
      this.emailValue = '';
      this.emailError = '';
      return;
    }

    if (field === 'mobile') {
      this.mobileValue = '';
      this.mobileError = '';
      return;
    }

    this.passwordValue = '';
    this.passwordError = '';
  }

  validateAndSubmit(): void {
    this.nameError = '';
    this.emailError = '';
    this.mobileError = '';
    this.passwordError = '';
    this.registerError = '';

    const name = this.nameValue.trim();
    const email = this.emailValue.trim();
    const mobile = this.mobileValue.trim();
    const password = this.passwordValue;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileDigitsRegex = /^\d+$/;

    let hasError = false;

    if (name.length < 2) {
      this.nameError = 'REGISTER.ERROR_NAME_REQUIRED';
      hasError = true;
    }

    if (!emailRegex.test(email)) {
      this.emailError = 'REGISTER.ERROR_INVALID_EMAIL';
      hasError = true;
    }

    if (
      mobile.length > 0 &&
      (!mobileDigitsRegex.test(mobile) || mobile.length < 7)
    ) {
      this.mobileError = 'REGISTER.ERROR_INVALID_MOBILE';
      hasError = true;
    }

    if (!password || password.trim().length < 6) {
      this.passwordError = 'REGISTER.ERROR_INVALID_PASSWORD';
      hasError = true;
    }

    if (hasError) {
      return;
    }

    this.isLoading = true;

    this.authService
      .register(email, name, password, mobile)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          const lang = this.route.snapshot.paramMap.get('lang') || 'en';
          this.router.navigateByUrl(`/${lang}/home`);
        },
        error: (error) => {
          if (
            error?.status === 409 ||
            error?.error?.message === 'Email already exists'
          ) {
            this.registerError = 'REGISTER.ERROR_EMAIL_EXISTS';
            return;
          }

          this.registerError =
            error?.error?.message || 'REGISTER.ERROR_REGISTER_FAILED';
        },
      });
  }

  navigateToLogin(): void {
    const lang = this.route.snapshot.paramMap.get('lang') || 'en';
    this.router.navigateByUrl(`/${lang}/login`);
  }
}
